function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp import/no-extraneous-dependencies */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { WDHComponent, onResize, resolveImageSrc } from '@demant/wdh';
import { SiteCoreLink, SiteCoreList } from './sitecore-content-parser';
var DemantGraduateBlogHeader = /*#__PURE__*/function (_WDHComponent) {
  function DemantGraduateBlogHeader() {
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'header';
    _classCallCheck(this, DemantGraduateBlogHeader);
    return _callSuper(this, DemantGraduateBlogHeader, [className]);
  }
  _inherits(DemantGraduateBlogHeader, _WDHComponent);
  return _createClass(DemantGraduateBlogHeader, [{
    key: "init",
    value: function init(component) {
      var navigation = component.querySelector('.component.navigation ul');
      var rootLink = component.querySelector('.component.link a.root');
      var homeLink = component.querySelector('.component.link a.graduate-blog');
      var bannerImage = component.querySelector('.component.intro-banner .intro-banner-image img');
      this.app = /*#__PURE__*/React.createRef();
      ReactDOM.render(/*#__PURE__*/React.createElement(DemantGraduateBlogHeaderApp, {
        ref: this.app,
        navigation: navigation,
        rootLink: rootLink,
        homeLink: homeLink,
        bannerImage: bannerImage
      }), component);
    }
  }]);
}(WDHComponent);
var DemantGraduateBlogHeaderApp = /*#__PURE__*/function (_React$Component) {
  function DemantGraduateBlogHeaderApp(props) {
    var _this;
    _classCallCheck(this, DemantGraduateBlogHeaderApp);
    _this = _callSuper(this, DemantGraduateBlogHeaderApp, [props]);
    _this.state = {
      isDesktop: _this.isDesktop(),
      mobileOpen: false,
      navigation: props.navigation
    };
    _this.openMobileMenu = _this.openMobileMenu.bind(_this);
    _this.closeMobileMenu = _this.closeMobileMenu.bind(_this);
    _this.freezeScrollingOnIOS = _this.freezeScrollingOnIOS.bind(_this);
    _this.updateMobileState = _this.updateMobileState.bind(_this);
    return _this;
  }
  _inherits(DemantGraduateBlogHeaderApp, _React$Component);
  return _createClass(DemantGraduateBlogHeaderApp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      onResize(function () {
        _this2.updateMobileState();
      });
    }
  }, {
    key: "freezeScrollingOnIOS",
    value: function freezeScrollingOnIOS(event) {
      event.preventDefault();
    }
  }, {
    key: "openMobileMenu",
    value: function openMobileMenu(event) {
      event.preventDefault();
      if (this.state.mobileSearch) {
        this.setState({
          mobileSearch: false
        });
        this.resetSearch();
      } else if (this.state.mobileOpen) {
        this.closeMobileMenu(event);
      } else {
        // this.scrollTop = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0); TODO. Test if scroll on mobile is still fine. Then delete.
        document.body.style.position = 'fixed';
        document.body.style.top = "".concat(this.scrollTop, "px");
        this.setState({
          mobileOpen: true
        });
      }
    }
  }, {
    key: "closeMobileMenu",
    value: function closeMobileMenu(event) {
      event.preventDefault();
      clearTimeout(this.blockScrollTimeout);
      document.body.style.position = 'static';
      window.scrollTo(0, this.scrollTop);
      this.setState({
        mobileOpen: false,
        secondLevelNavigation: null
      });
    }
  }, {
    key: "updateMobileState",
    value: function updateMobileState() {
      var isDesktop = this.isDesktop();
      if (isDesktop !== this.state.isDesktop) {
        this.setState({
          isDesktop: isDesktop,
          mobileOpen: false
        });
      }
    }
  }, {
    key: "isDesktop",
    value: function isDesktop() {
      return window.matchMedia('(min-width:992px)').matches;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "header-graduate-blog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "banner"
      }, /*#__PURE__*/React.createElement("img", {
        src: resolveImageSrc(this.props.bannerImage),
        alt: ""
      }), /*#__PURE__*/React.createElement("div", {
        className: "header-links"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-links-container"
      }, /*#__PURE__*/React.createElement(SiteCoreLink, {
        htmlAnchorElement: this.props.homeLink
      }), /*#__PURE__*/React.createElement(SiteCoreLink, {
        htmlAnchorElement: this.props.rootLink
      }, /*#__PURE__*/React.createElement("img", {
        src: "/design/build/demant2019/assets/demant-logo.svg",
        alt: "logo"
      }))))), !this.state.isDesktop && /*#__PURE__*/React.createElement("div", {
        className: "mobile-graduate-blog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mobile-container ".concat(this.state.mobileOpen ? 'active' : '')
      }, /*#__PURE__*/React.createElement("a", {
        href: "/"
      }, /*#__PURE__*/React.createElement("img", {
        className: "logo",
        src: "/design/build/demant2019/assets/demant-logo-negative.svg",
        alt: "logo"
      })), /*#__PURE__*/React.createElement("div", {
        className: "navigation-container ".concat(this.state.secondLevelNavigation ? 'animate-out' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "navigation"
      }, /*#__PURE__*/React.createElement(SiteCoreList, {
        htmlUListElement: this.state.navigation
      })))), /*#__PURE__*/React.createElement("button", {
        className: "open ".concat(this.state.mobileOpen ? 'close' : '', " ").concat(this.state.mobileSearch ? 'upper' : ''),
        onClick: this.openMobileMenu
      }, /*#__PURE__*/React.createElement("span", null, "\xA0"), /*#__PURE__*/React.createElement("span", null, "\xA0"), /*#__PURE__*/React.createElement("span", null, "\xA0"))), this.state.isDesktop && /*#__PURE__*/React.createElement("div", {
        className: "desktop-graduate-blog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "main-menu-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "main-menu"
      }, /*#__PURE__*/React.createElement(SiteCoreList, {
        htmlUListElement: this.props.navigation,
        onClick: this.handleMainMenuClick
      })))));
    }
  }]);
}(React.Component);
DemantGraduateBlogHeaderApp.propTypes = {
  navigation: PropTypes.instanceOf(HTMLUListElement).isRequired,
  homeLink: PropTypes.instanceOf(HTMLAnchorElement).isRequired,
  rootLink: PropTypes.instanceOf(HTMLAnchorElement).isRequired,
  bannerImage: PropTypes.instanceOf(HTMLImageElement).isRequired
};
DemantGraduateBlogHeaderApp.defaultProps = {};
var header = new DemantGraduateBlogHeader();
header.run();